import { render, staticRenderFns } from "./sizes.vue?vue&type=template&id=51165a6b&"
import script from "./sizes.vue?vue&type=script&lang=js&"
export * from "./sizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports